
	import {
		Component,
		Vue,
		Inject,
		Prop,
		Watch
	} from 'vue-property-decorator';
	import wx from 'weixin-js-sdk';
	import Util from '@/lib/util';
	import AbpBase from '@/lib/abpbase';
	import QuestionTpl from '@/store/entities/questiontpl'
	import QuestionTplDet from '@/store/entities/questiontpldet'
	import QuestionTplUser from '@/store/entities/questiontpluser'
	import QuestionTplDetValue from '@/store/entities/questiontpldetvalue'
	@Component({
		components: {

		}
	})

	export default class QuestionnaireUser extends AbpBase {
		userAgent: string = "";
		qid: number = 0;
		quid: number = 0;
		questionTpl: QuestionTpl = new QuestionTpl();
		inputtext: string = "";
		questionTplDetList: Array < QuestionTplDet >= new Array < QuestionTplDet > ();
		imgBox: boolean = false;
		disabled: boolean = false;
		userId: number = 0;
		submitQuestionUser: QuestionTplUser = new QuestionTplUser();
		showShare: boolean = false;
		msg: string = '';

		share() {
			this.showShare = true;
		}
		isIos() {
			var u = navigator.userAgent.toLowerCase();
			this.userAgent = u;
			if (u.indexOf("iphone") > -1 || u.indexOf("ios") > -1 || u.indexOf("mac") > -1) {
				return true;
			}
			return false;
		}
		shareToWeixin(shareWeixinType) {
			var that = this;
			var questionTpl = (this.questionTpl as any);
			var title = questionTpl.name;
			var link = location.protocol + "//" + location.host + "/#/questionnaireuser?qid=" + questionTpl.id;
			var content = questionTpl.desc;
			var coverImg = questionTpl.pic;
			if (content == '') {
				content = title;
				title = '';
			}
			if (that.isIos()) {
				if (coverImg != null && coverImg.length > 0) {
					that.$store.dispatch({
						type: 'app/refreshOSSPresignedUri',
						data: {
							url: coverImg,
							process: 'image/resize,m_fixed,w_30,h_30'
						}
					}).then(res => {
						coverImg = res;
						that.gisShareToWeixin(title, content, link, coverImg, shareWeixinType);
					});
				} else {
					that.gisShareToWeixin(title, content, link, coverImg, shareWeixinType);
				}

			} else {
				that.gisShareToWeixin(title, content, link, coverImg, shareWeixinType);
			}

		}
		gisShareToWeixin(title, content, link, coverImg, shareWeixinType) {
			var that = this;
			// shareWeixinType: string = "WXSceneSession" // WXSceneTimeline
			(window as any).gis.shareToWeixin({
				type: 'web',
				title: title,
				content: content,
				href: link,
				thumbs: [coverImg],
				extra: {
					scene: shareWeixinType
				},
				// pictures:[news.coverImg],
				success: function() {
					that.showShare = false;
					//that.createNewsOperation(3);
				},
				fail: function() {
					that.showShare = false;
				}
			})
		}
		isWeiXin() {
			var ua = navigator.userAgent.toLowerCase() as any;
			this.userAgent = ua;
			if (ua.match(/MicroMessenger/i) == 'micromessenger') {
				return true; // 是微信端
			} else {
				return false;
			}
		}
		weixinShare() {
			var that = this;
			if (this.isWeiXin()) {
				var questionTpl = that.questionTpl as any;
				var url = location.href.split('#')[0];
				that.msg = that.msg + 'is weixin';
				this.$store.dispatch({
					type: 'app/getWeixinJSSDKConfig',
					data: {
						url: url
					}
				}).then(res => {
					var config = res;
					wx.config({
						debug: false,
						appId: config.appId, // 必填，公众号的唯一标识
						timestamp: config.timestamp, // 必填，生成签名的时间戳
						nonceStr: config.nonceStr, // 必填，生成签名的随机串
						signature: config.signature, // 必填，签名
						jsApiList: ['checkJsApi',
							'onMenuShareTimeline',
							'onMenuShareAppMessage',
						] // 必填，需要使用的JS接口列表
					});
					that.msg = that.msg + ' configed';
					wx.ready(function() { //需在用户可能点击分享按钮前就先调用
						that.msg = that.msg + ' ready';
						wx.updateAppMessageShareData({
							title: questionTpl.name, // 分享标题
							desc: questionTpl.desc, // 分享描述
							link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
							imgUrl: questionTpl.pic, // 分享图标
							success: function() {
								// 设置成功

							}
						})
						wx.onMenuShareAppMessage({
							title: questionTpl.name, // 分享标题
							desc: questionTpl.desc, // 分享描述
							link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
							imgUrl: questionTpl.pic, // 分享图标
							type: 'link', // 分享类型,music、video或link，不填默认为link
							dataUrl: '', // 如果type是music或video，则要提供数据链接，默认为空
							success: function() {
								// 用户点击了分享后执行的回调函数
							},
							cancel:function(){
								
							},
						});
						wx.onMenuShareTimeline({
							title: questionTpl.name, // 分享标题
							link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
							imgUrl: questionTpl.pic, // 分享图标
							success: function() {
								// 用户点击了分享后执行的回调函数
							},							
							cancel:function(){
								
							},
						});
						wx.updateTimelineShareData({
							title: questionTpl.name, // 分享标题
							link: location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
							imgUrl: questionTpl.pic, // 分享图标
							success: function() {
								// 设置成功
							}
						})
					});

				})
			}

		}



		radioChange(e, index) {
			var that = this;
			var each = that.questionTplDetList[index];
			each.content = e;
			that.$forceUpdate();
		}
		checkboxChange(e, index) {
			var that = this;
			var each = that.questionTplDetList[index];
			each.contentlist = e;
			each.content = e.toString();
			that.$forceUpdate();
		}

		saveQuestion() {
			var that = this;
			var isRequired = "";
			for (var i = 0; i < that.questionTplDetList.length; i++) {
				if (that.questionTplDetList[i].isMust && (that.questionTplDetList[i].content == null || that
						.questionTplDetList[i].content == '')) {
					if (isRequired == "") {
						isRequired = that.questionTplDetList[i].sort.toString();
					} else {
						isRequired = isRequired + ',' + that.questionTplDetList[i].sort.toString();
					}
					// uni.showModal({
					// 	title: this.L('Tips'),
					// 	content: that.L('ItemRequired').replace("{0}", that.questionTplDetList[i].sort),
					// 	showCancel: false,
					// 	confirmText: this.L('OK'),
					// })
					// return;
				} else {
					if (that.questionTplDetList[i].questionValueType == 6 && that.questionTplDetList[i].content != null &&
						that
						.questionTplDetList[i].content != '') {
						that.questionTplDetList[i].content = Util.changeDate(that.questionTplDetList[i].content) as any;
					}

				}
			}
			if (isRequired != "") {
				this.$Modal.confirm({
					title: this.L('Tips'),
					content: this.L('ItemRequired').replace("{0}", isRequired),
					okText: this.L('OK'),
					cancelText: this.L('Cancel'),
				})
				return;
			}
			var errorCount = 0;
			var isShowError = false;
			if (that.questionTpl.isShowError != null && that.questionTpl.isShowError) {
				isShowError = true;
			}

			var isMustRuired = "";
			var isMustError = "";
			if (that.questionTpl.isVerifyAnswer != null && that.questionTpl.isVerifyAnswer) {
				for (var i = 0; i < that.questionTplDetList.length; i++) {
					if (that.questionTplDetList[i].answer != null && that.questionTplDetList[i].answer != '') {
						if ((that.questionTplDetList[i].content == null || that
								.questionTplDetList[i].content == '')) {
							if (isMustRuired == "") {
								isMustRuired = that.questionTplDetList[i].sort.toString();
							} else {
								isMustRuired = isMustRuired + ',' + that.questionTplDetList[i].sort.toString();
							}
							continue;
							// uni.showModal({
							// 	title: this.L('Tips'),
							// 	content: that.L('ItemRequired').replace("{0}", that.questionTplDetList[i]
							// 		.sort),
							// 	showCancel: false,
							// 	confirmText: this.L('OK'),
							// })
							// return;
						}
						if (that.questionTplDetList[i].questionValueType == 1 && that.questionTplDetList[i].detTpl !=
							'sex') {
							var answer = "";
							var detValueList = that.questionTplDetList[i].questionTplDetValueList;
							for (var j = 0; j < detValueList.length; j++) {
								if (that.questionTplDetList[i].content.trim() == detValueList[j].id.toString()) {
									answer = detValueList[j].shortName;
									break;
								}
							}
							if (that.questionTplDetList[i].answer.trim() != answer.trim()) {
								errorCount++;
								if (!isShowError) {
									if (isMustError == "") {
										isMustError = that.questionTplDetList[i].sort.toString();
									} else {
										isMustError = isMustError + ',' + that.questionTplDetList[i].sort.toString();
									}
									continue
									// uni.showModal({
									// 	title: this.L('Tips'),
									// 	content: that.L('ItemError').replace("{0}", that
									// 		.questionTplDetList[
									// 			i].sort),
									// 	showCancel: false,
									// 	confirmText: this.L('OK'),
									// })
									// return;
								}
							}
						} else if (that.questionTplDetList[i].questionValueType == 2 && that.questionTplDetList[i]
							.detTpl != 'sex') {
							var answer = "";
							var answerContent = that.questionTplDetList[i].content.split(',')
							var detValueList = that.questionTplDetList[i].questionTplDetValueList;

							for (var j = 0; j < detValueList.length; j++) {
								for (var k = 0; k < answerContent.length; k++) {
									if (answerContent[k] == detValueList[j].id.toString()) {
										if (answer == '') {
											answer = detValueList[j].shortName;
										} else {
											answer = answer + "," + detValueList[j].shortName;
										}

									}
								}
							}

							var answerArr = that.questionTplDetList[i].answer.split(',');
							var contentArr = answer.split(',')

							//交集
							var intersection = answerArr.filter(v => contentArr.includes(v));
							//差集
							var difference = answerArr.concat(contentArr).filter(v => !answerArr.includes(v) || !
								contentArr.includes(v));

							if (!(intersection.length == answerArr.length && difference.length == 0)) {
								errorCount++;
								if (!isShowError) {
									if (isMustError == "") {
										isMustError = that.questionTplDetList[i].sort.toString();
									} else {
										isMustError = isMustError + ',' + that.questionTplDetList[i].sort.toString();
									}
									continue
									// uni.showModal({
									// 	title: this.L('Tips'),
									// 	content: that.L('ItemError').replace("{0}", that
									// 		.questionTplDetList[
									// 			i].sort),
									// 	showCancel: false,
									// 	confirmText: this.L('OK'),
									// })

									// return;
								}
							}
						}
					}

				}
			}
			if (isMustRuired != '' || isMustError != '') {
				var content = "";
				if (isMustRuired != '') {
					content = this.L('ItemRequired').replace("{0}", isRequired);
				}
				if (isMustError != '') {
					if (content != '') {
						content += " ; " + this.L('ItemError').replace("{0}", isMustError);
					} else {
						content = this.L('ItemError').replace("{0}", isMustError);
					}
				}
				this.$Modal.confirm({
					title: this.L('Tips'),
					content: content,
					okText: this.L('OK'),
					cancelText: this.L('Cancel'),
				})
				return;
			}

			this.$Modal.confirm({
				title: this.L('Tips'),
				content: this.L('SubmitConfirm'),
				okText: this.L('OK'),
				cancelText: this.L('Cancel'),
				onOk: async () => {
					that.disabled = true;
					this.$Message.loading({
						content: this.L('保存中'),
						duration: 3
					});
					that.questionTpl.questionTplDetList = that.questionTplDetList;
					that.questionTpl.users = null;
					that.questionTpl.organizations = null;
					that.questionTpl.createUser = null;
					that.$store.dispatch({
						type: 'app/createQuestionUser',
						data: that.questionTpl
					}).then((res) => {
						that.$Message.destroy();
						if (res > 0) {
							that.quid = res;
							if (isShowError) {
								if (errorCount == 0) {
									setTimeout(() => {
										that.$Modal.info({
											title: this.L('Tips'),
											content: this.L('SubmitSuccess'),
											okText: this.L('确定'),
											cancelText: this.L('取消'),	
											onOk: async () => {
												that.loadQuestionTplByUserId();
											}
										})
									}, 500)

									// that.$Message.success("提交成功");	
									// that.loadQuestionTplByUserId();
								} else {
									setTimeout(() => {
										that.$Modal.info({
											title: this.L('Tips'),
											content: this.L('AnswerError'),
											okText: this.L('确定'),
											cancelText: this.L('取消'),	
											onOk: async () => {
												that.loadQuestionTplByUserId();
											}
										})
									}, 500)

								}
							} else {
								setTimeout(() => {
									that.$Modal.info({
										title: this.L('Tips'),
										content: this.L('SubmitSuccess'),
										okText: this.L('确定'),
										cancelText: this.L('取消'),	
										onOk: async () => {
											that.loadQuestionTplByUserId();
										}
									})
								}, 500)

								// that.$Message.success("提交成功");	
								// that.loadQuestionTplByUserId();
							}

						} else {
							that.disabled = false;
							//that.$Message.error("提交失败");	
							setTimeout(() => {
								that.$Modal.error({
									title: this.L('Tips'),
									content: this.L('提交失败'),
									okText: this.L('确定'),
									cancelText: this.L('取消'),	
								})
							}, 500)


						}

					}).catch(res => {
						that.disabled = false;
					});
				}
			});

		}

		@Watch('$route')
		routechange(to: any, from: any) {
			if (to.query.qid != from.query.qid) {
				location.reload();
			}
		}


		getQuestionTplById() {
			var that = this;
			this.$store.dispatch({
				type: 'app/getQuestionTplById',
				id: this.qid
			}).then((res) => {
				console.log(res);
				that.questionTpl = res;
				that.questionTplDetList = that.questionTpl.questionTplDetList;
				for (var i = 0; i < that.questionTplDetList.length; i++) {
					that.questionTplDetList[i].content = "";
					that.questionTplDetList[i].contentlist = [];
				}
				that.weixinShare();
				// uni.setNavigationBarTitle({
				// 	title: that.questionTpl.name
				// })
				console.log(that.questionTpl);

			})
		}

		loadQuestionTplByUserId() {
			var that = this;
			this.$store.dispatch({
				type: 'app/getQuestionByUserId',
				id: this.quid
			}).then(res => {
				that.questionTpl = res;
				that.questionTplDetList = that.questionTpl.questionTplDetList;
				console.log(that.questionTpl);
			})
		}

		async created() {
			var that = this;
			console.log(Util.abp.session.userId);
			if (!Util.abp.session.userId && Util.abp.session.userId != null) {
				var domain = this.$route.query.domain as any;
				if (domain != undefined && domain != null && domain != '') {
					await this.$store.dispatch({
						type: 'app/externalAuthenticate',
						data: {
							"AuthProvider": "IDSDOMAIN",
							"ProviderAccessCode": domain,
							ProviderKey: "",
							Property: ""
						},
					})
					location.reload();
				}
				var userId = this.$route.query.userid as any;
				if (userId != undefined && userId != null && userId != '') {
					// that.userId=userId as any;
					await this.$store.dispatch({
						type: 'app/externalAuthenticate',
						data: {
							"AuthProvider": "IDSID",
							"ProviderAccessCode": userId,
							ProviderKey: userId,
							Property: ""
						},
					})
					location.reload();
				}
			}
			if (this.$route.query.qid && (this.$route.query.qid as any) > 0) {
				this.qid = this.$route.query.qid as any;

				this.getQuestionTplById();
			} else {

			}

		}

	}
